import { TriangleAlert } from "lucide-react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";
import { useT } from "../i18n";

export function ErrorBoundary() {
  const t = useT();
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : t("Lỗi không xác định", "Unknown error");
  return (
    <div className="container" style={{ padding: "3rem 1.25rem", maxWidth: 640 }}>
      <h1><TriangleAlert className="ico" size={28} aria-hidden="true" />{t("Đã xảy ra lỗi", "Something went wrong")}</h1>
      <p className="muted">{t("Ứng dụng gặp sự cố khi hiển thị trang này. Tiến độ của bạn vẫn an toàn trong trình duyệt.", "The app hit a problem rendering this page. Your progress is still safe in your browser.")}</p>
      <pre><code>{message}</code></pre>
      <div className="row">
        <Link className="btn primary" to="/">{t("Về trang chủ", "Back to home")}</Link>
        <button type="button" className="btn" onClick={() => window.location.reload()}>{t("Tải lại", "Reload")}</button>
      </div>
    </div>
  );
}
